<template>
    <div v-if="!$route.path.includes('products')" class="uploading-progress">
        <v-scale-transition>
            <v-alert v-if="uploading" class="alert" key="uploading">
                <div class="w-100">
                    <div class="w-100 font-weight-bold grey--text">{{$t('Uploading')}}</div>
                    <v-progress-linear v-if="progress" color="light-blue" height="10" :value="progress" striped></v-progress-linear>
                </div>
            </v-alert>
        </v-scale-transition>
        <v-scale-transition>
            <v-alert :type="message.type" v-if="message" class="alert" key="uploading">
                <span>{{message.text}}</span>
            </v-alert>
        </v-scale-transition>
    </div>
</template>
<script>
    export default {
        data:() => {
            return{
                progress: null,
                uploading: false,
                message: null,
            }
        },
        mounted(){
            this.$root.$eventBus.$on('uploadingProgress', percent => {
                this.progress = percent;
                if(!this.uploading) this.uploading = true;
                if(this.percent >= 100){
                    this.finishUploading();
                }
            })
            this.$root.$eventBus.$on('stopUploading', valid => {
                if(this.uploading){
                    this.finishUploading(valid);
                }
            })
        },
        methods:{
            finishUploading(valid = null){
                setTimeout(() => {
                    if(valid == true) this.message = {text: this.$t('Uploaded succesfully'), type: 'success'};
                    if(valid == false) this.message = {text: this.$t('Uploading failed. Try again later or make your file smaller.'), type: 'error'};
                    this.uploading = false;
                    setTimeout(() => {
                        this.message = null;
                    },3000)
                },1500)
            }
        }
    }
</script>
<style lang="scss">
    .uploading-progress{
        position: fixed;
        width: 20%;
        top: 15%;
        right: calc(80% / 2);
        z-index: 99999;
        .alert{
            -webkit-box-shadow: 8px 8px 16px 0px rgba(0,0,0,0.15);
            -moz-box-shadow: 8px 8px 16px 0px rgba(0,0,0,0.15);
            box-shadow: 8px 8px 16px 0px rgba(0,0,0,0.15);
        }
    }
</style>
